// extracted by mini-css-extract-plugin
export default {"noticeWrap":"Notice_noticeWrap__vMSuk","contentWrap":"Notice_contentWrap__5ei6T"};